import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule, NgClass} from '@angular/common';
import {MacroColorGroup} from '@app/model-composer/models/customization.model';

@Component({
  selector: 'app-macro-color-selector',
  standalone: true,
  imports: [CommonModule, NgClass],
  template: `
    <div class="ipe:flex ipe:flex-wrap ipe:gap-3">
      @for (item of items; track item.id) {
        @let isActive = item.id === activeId;
        <button
          type="button"
          class="
            ipe:cursor-pointer
            ipe:group
            ipe:w-20
            ipe:select-none
            ipe:rounded-xl
            ipe:p-2
            ipe:transition
            ipe:duration-200
            ipe:focus-visible:outline-none
            ipe:focus-visible:ring-1
            ipe:ring-offset-white
          "
          [attr.aria-pressed]="isActive"
          (click)="select.emit(item.id)"
          [style.--accent]="item.hex"
        >
          <span
            class="
              ipe:mx-auto
              ipe:block
              ipe:h-12
              ipe:w-12
              ipe:rounded-full
              ipe:border
              ipe:border-black/10
              ipe:shadow-sm
              ipe:transition
              ipe:duration-200
              ipe:group-hover:scale-105
            "
            [style.background]="item.hex"
            [ngClass]="isActive ? 'ipe:ring-1 ipe:ring-[var(--accent)] ipe:ring-offset-white' : ''"
          ></span>
          <span
            class="ipe:mt-2 ipe:block ipe:text-center ipe:text-[11px] ipe:leading-tight"
            [ngClass]="isActive ? 'ipe:text-gray-900 ipe:font-medium' : 'ipe:text-gray-500'"
            title="{{ item.label }}"
          >
            {{ item.label }}
          </span>
        </button>
      }
    </div>
  `,
  styles: [
    `
      @import 'tailwindcss' prefix(ipe);
      @theme {
        --font-display: 'ABC Walter Neue', sans-serif;
        --font-roboto: 'ABC Walter Neue', sans-serif;
        --font-sans: 'ABC Walter Neue', sans-serif;
      }
    `
  ],
})
export class MacroColorSelectorComponent {
  @Input({ required: true }) items: MacroColorGroup[] = [];
  @Input() activeId: string | null = null;
  @Output() select = new EventEmitter<string>();
}
